// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Menu } from "semantic-ui-react";
import DashboardBarButtonAjouter from "./DashboardBarButtonAjouter";
import DashboardBarButtonPrecedent from "./DashboardBarButtonPrecedent";
import DashboardBarButtonSuivant from "./DashboardBarButtonSuivant";
import DashboardBarButtonSupprimer from "./DashboardBarButtonSupprimer";
import { DashboardService } from "../services";
import useIndex from "../hooks/useIndex";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardBar = () => {
  const [dashboards, loading] = DashboardService.queryDashboards();
  const [current, [currentIndex, maxIndex], [incrementIndex, decrementIndex]] = useIndex(dashboards);
  const handlePrecedent = React.useCallback(() => {
    incrementIndex();
  }, [incrementIndex]);
  const handleSuivant = React.useCallback(() => {
    decrementIndex();
  }, [decrementIndex]);
  const handleAjouter = React.useCallback(dashboard => {
    DashboardService.addDashboard(dashboard);
  }, []);
  const handleSupprimer = React.useCallback(() => {
    DashboardService.deleteDashboard(current.identifiant);
  }, [current]);
  const actions = React.useMemo(() => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DashboardBarButtonAjouter, {
      onClick: handleAjouter,
      disabled: loading
    }), /*#__PURE__*/_jsx(DashboardBarButtonSupprimer, {
      onClick: handleSupprimer,
      disabled: !current
    })]
  }), [loading, current, handleAjouter, handleSupprimer]);
  const navigation = React.useMemo(() => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DashboardBarButtonPrecedent, {
      disabled: currentIndex <= 1 || loading,
      onClick: handlePrecedent
    }), /*#__PURE__*/_jsx(DashboardBarButtonSuivant, {
      disabled: currentIndex >= maxIndex || loading,
      onClick: handleSuivant
    })]
  }), [loading, maxIndex, currentIndex, handlePrecedent, handleSuivant]);
  return /*#__PURE__*/_jsxs(Menu, {
    className: "dashboard-bar",
    secondary: true,
    fluid: true,
    icon: "labeled",
    "data-sentry-element": "Menu",
    "data-sentry-component": "DashboardBar",
    "data-sentry-source-file": "DashboardBar.tsx",
    children: [navigation, actions]
  });
};
export default DashboardBar;